import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { PATH_URL } from "src/interfaces";
import {
  QUERY_STRING_HOTEL_DETAIL_ID,
  QUERY_STRING_OPEN_ROOM_DETAIL,
  QUERY_STRING_PLAN_ID,
  QUERY_STRING_RESALE_DETAIL_ID,
  QUERY_STRING_RESALE_RESERVATION_DETAIL_ID,
} from "src/interfaces/defineQueryStringProperties";
import "./index.scss";
import { isMobile } from "react-device-detect";
import { HomeIcon } from "src/assets/icons";

export enum PAGE_BREADCRUMB {
  hotel_list = "hotel_list",
  hotel_detail = "hotel_detail",
  hotel_reservation_1 = "hotel_reservation_1",
  hotel_reservation_2 = "hotel_reservation_2",
  hotel_reservation_3 = "hotel_reservation_3",
  my_page = "my_page",
  reservation_list = "reservation_list",
  resale_reservation_list = "resale_reservation_list",
  reservation_detail = "reservation_detail",
  resale_reservation_detail = "resale_reservation_detail",
  resale_list_during = "resale_list_during",
  resale_detail = "resale_detail",
  resale_reservation_1 = "resale_reservation_1",
  resale_reservation_2 = "resale_reservation_2",
  resale_reservation_3 = "resale_reservation_3",
  resale_push_to_market = "resale_push_to_market",
  user_profile = "user_profile",
  sale_management = "sale_management",
}

interface IProps {
  page: PAGE_BREADCRUMB;
  isResale?: boolean;
  changePageCallback?: (page: string) => void;
  style?: React.CSSProperties;
}

const path_hotel_list = PATH_URL.HOTEL_LIST;
const path_hotel_detail = PATH_URL.HOTEL_DETAIL;
const path_room_detail = PATH_URL.ROOM_DETAIL;
const path_my_page = PATH_URL.RESERVATION_MY_PAGE;
const path_my_page_resale = PATH_URL.RESALE_MY_PAGE;
const path_resale_list = PATH_URL.RESALE_LIST;
const path_resale_detail = PATH_URL.RESALE_DETAIL;
const path_reservation_list = PATH_URL.RESERVATION_LIST;
const path_reservation_list_resale = PATH_URL.RESALE_RESERVATION_LIST;
const path_reservation_detail_resale = PATH_URL.RESALE_RESERVATION_DETAIL;

const list: any = {
  [PAGE_BREADCRUMB.hotel_list]: [
    {
      key_translate: "breadcrumb.hotel-list",
      path: "",
    },
  ],
  [PAGE_BREADCRUMB.hotel_detail]: [
    {
      key_translate: "breadcrumb.hotel-list",
      path: path_hotel_list,
    },
    {
      key_translate: "breadcrumb.hotel-detail",
      path: "",
    },
  ],
  [PAGE_BREADCRUMB.hotel_reservation_1]: [
    {
      key_translate: "breadcrumb.hotel-list",
      path: path_hotel_list,
    },
    {
      key_translate: "breadcrumb.hotel-detail",
      path: path_hotel_detail,
    },
    {
      key_translate: "breadcrumb.hotel-room-detail",
      path: path_room_detail,
    },
    {
      key_translate: "breadcrumb.hotel-reservation_1",
      path: "",
    },
  ],
  [PAGE_BREADCRUMB.hotel_reservation_2]: [
    {
      key_translate: "breadcrumb.hotel-list",
      path: path_hotel_list,
    },
    {
      key_translate: "breadcrumb.hotel-detail",
      path: path_hotel_detail,
    },
    {
      key_translate: "breadcrumb.hotel-room-detail",
      path: path_room_detail,
    },
    {
      key_translate: "breadcrumb.hotel-reservation_1",
      path: "",
      page: "1",
    },
    {
      key_translate: "breadcrumb.hotel-reservation_2",
      path: "",
    },
  ],
  [PAGE_BREADCRUMB.hotel_reservation_3]: [
    {
      key_translate: "breadcrumb.hotel-list",
      path: path_hotel_list,
    },
    {
      key_translate: "breadcrumb.hotel-detail",
      path: path_hotel_detail,
    },
    {
      key_translate: "breadcrumb.hotel-room-detail",
      path: path_room_detail,
    },
    {
      key_translate: "breadcrumb.hotel-reservation_1",
      path: "",
      page: "1",
    },
    {
      key_translate: "breadcrumb.hotel-reservation_3",
      path: "",
    },
  ],
  [PAGE_BREADCRUMB.my_page]: [
    {
      key_translate: "breadcrumb.my-page",
      path: "",
    },
  ],
  [PAGE_BREADCRUMB.reservation_list]: [
    {
      key_translate: "breadcrumb.my-page",
      path: path_my_page,
    },
    {
      key_translate: "breadcrumb.reservation-management",
      path: "",
    },
  ],
  [PAGE_BREADCRUMB.resale_reservation_list]: [
    {
      key_translate: "breadcrumb.my-page",
      path: path_my_page_resale,
    },
    {
      key_translate: "breadcrumb.reservation-management",
      path: "",
    },
  ],
  [PAGE_BREADCRUMB.reservation_detail]: [
    {
      key_translate: "breadcrumb.my-page",
      path: path_my_page,
    },
    {
      key_translate: "breadcrumb.reservation-management",
      path: path_reservation_list,
    },
    {
      key_translate: "breadcrumb.reservation-detail",
      path: "",
    },
  ],
  [PAGE_BREADCRUMB.resale_reservation_detail]: [
    {
      key_translate: "breadcrumb.my-page",
      path: path_my_page_resale,
    },
    {
      key_translate: "breadcrumb.reservation-management",
      path: path_reservation_list_resale,
    },
    {
      key_translate: "breadcrumb.reservation-detail",
      path: "",
    },
  ],
  [PAGE_BREADCRUMB.resale_list_during]: [
    {
      key_translate: "breadcrumb.resale-list",
      path: "",
    },
  ],
  [PAGE_BREADCRUMB.resale_detail]: [
    {
      key_translate: "breadcrumb.resale-list",
      path: path_resale_list,
    },
    {
      key_translate: "breadcrumb.resale-detail",
      path: "",
    },
  ],
  [PAGE_BREADCRUMB.resale_reservation_1]: [
    {
      key_translate: "breadcrumb.resale-list",
      path: path_resale_list,
    },
    {
      key_translate: "breadcrumb.resale-detail",
      path: path_resale_detail,
    },
    {
      key_translate: "breadcrumb.resale-reservation_1",
      path: "",
    },
  ],
  [PAGE_BREADCRUMB.resale_reservation_2]: [
    {
      key_translate: "breadcrumb.resale-list",
      path: path_resale_list,
    },
    {
      key_translate: "breadcrumb.resale-detail",
      path: path_resale_detail,
    },
    {
      key_translate: "breadcrumb.resale-reservation_2",
      path: "",
    },
  ],
  [PAGE_BREADCRUMB.resale_reservation_3]: [
    {
      key_translate: "breadcrumb.resale-list",
      path: path_resale_list,
    },
    {
      key_translate: "breadcrumb.resale-detail",
      path: path_resale_detail,
    },
    {
      key_translate: "breadcrumb.resale-reservation_3",
      path: "",
    },
  ],
  [PAGE_BREADCRUMB.resale_push_to_market]: [
    {
      key_translate: "breadcrumb.reservation-detail",
      path: path_reservation_detail_resale,
    },
    {
      key_translate: "breadcrumb.resale-push-to-market",
      path: "",
    },
  ],
  [PAGE_BREADCRUMB.user_profile]: [
    {
      key_translate: "breadcrumb.my-page",
      path: path_my_page_resale,
    },
    {
      key_translate: "breadcrumb.user-profile",
      path: "",
    },
  ],
  [PAGE_BREADCRUMB.sale_management]: [
    {
      key_translate: "breadcrumb.my-page",
      path: path_my_page_resale,
    },
    {
      key_translate: "breadcrumb.sale_management",
      path: "",
    },
  ],
};

function BreadcrumbComponent({
  page,
  isResale,
  changePageCallback,
  style,
}: IProps) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleClickPreviourspage = (item: {
    key_translate: string;
    path: string;
    page?: string;
  }) => {
    const searchParams = new URLSearchParams(window.location.search);
    if (item.page) {
      // for case many layouts in 1 component
      changePageCallback && changePageCallback(item.page);
      return;
    }
    if (item.path) {
      switch (item.path) {
        case path_hotel_detail:
          const hotel_id = searchParams.get(`${QUERY_STRING_HOTEL_DETAIL_ID}`);
          if (searchParams.has(`${QUERY_STRING_OPEN_ROOM_DETAIL}`)) {
            searchParams.delete(`${QUERY_STRING_OPEN_ROOM_DETAIL}`);
          }
          if (searchParams.has(`${QUERY_STRING_PLAN_ID}`)) {
            searchParams.delete(`${QUERY_STRING_PLAN_ID}`);
          }
          return navigate(
            item.path + "/" + hotel_id + "?" + searchParams.toString()
          );
        case path_resale_detail:
          const resale_id = searchParams.get(
            `${QUERY_STRING_RESALE_DETAIL_ID}`
          );
          if (searchParams.has(`${QUERY_STRING_RESALE_DETAIL_ID}`)) {
            searchParams.delete(`${QUERY_STRING_RESALE_DETAIL_ID}`);
          }
          return navigate(
            item.path + "/" + resale_id + "?" + searchParams.toString()
          );
        case path_room_detail:
          const hotel_idd = searchParams.get(`${QUERY_STRING_HOTEL_DETAIL_ID}`);
          return navigate(
            PATH_URL.HOTEL_DETAIL +
              "/" +
              hotel_idd +
              "?" +
              searchParams.toString()
          );
        case path_reservation_detail_resale:
          const resale_re_id = searchParams.get(
            `${QUERY_STRING_RESALE_RESERVATION_DETAIL_ID}`
          );
          if (
            searchParams.has(`${QUERY_STRING_RESALE_RESERVATION_DETAIL_ID}`)
          ) {
            searchParams.delete(`${QUERY_STRING_RESALE_RESERVATION_DETAIL_ID}`);
          }
          return navigate(
            item.path + "/" + resale_re_id + "?" + searchParams.toString()
          );
        default:
          return navigate(item.path + "?" + searchParams.toString());
      }
    }
  };

  return (
    <div
      className={`BreadcrumbStyle ${isMobile ? "mobile-breadcrum" : ""}`}
      style={style}
    >
      {isMobile ? (
        <HomeIcon
          onClick={() => navigate(isResale ? "/resale/top" : "/")}
          width={12}
        />
      ) : (
        <HomeIcon onClick={() => navigate(isResale ? "/resale/top" : "/")} />
      )}

      {list[page].map((item: any, index: number) => {
        return (
          <React.Fragment key={index}>
            <span>{"/"}</span>
            <span
              className={`${
                isMobile ? "breadcrumb-item-mobile" : "breadcrumb-item"
              } ${index < list[page].length - 1 && "breadcrumb-underline"} `}
              onClick={() => handleClickPreviourspage(item)}
            >
              {t(item.key_translate)}
            </span>
          </React.Fragment>
        );
      })}
    </div>
  );
}

export default BreadcrumbComponent;
